import { useCallback } from 'react';

import useWorkspaceAccessControl, {
  UseWorkspaceAccessControlReturnType,
} from '@/components/WorkspaceAccessControl/hooks/useWorkspaceAccessControl';
import { WorkspaceActions, WorkspaceSubjects } from '@/types/schema';

import { BaseValidationType } from '../../hooks/useBaseEvents/events';

export interface WorkspaceAccessibleValidationType extends BaseValidationType {
  type: 'workspace-accessible';
  params: {
    workspaceAction: WorkspaceActions;
    workspaceSubject: WorkspaceSubjects;
    snackbarProps: Parameters<UseWorkspaceAccessControlReturnType['showPermissionSnackbar']>;
  };
}

const useWorkspaceAccessibleValidation = () => {
  const { isAccessible: isWorkspaceAccessible, showPermissionSnackbar } =
    useWorkspaceAccessControl();

  return useCallback(
    (event: WorkspaceAccessibleValidationType) => {
      const { workspaceAction, workspaceSubject, snackbarProps } = event.params;

      if (!isWorkspaceAccessible(workspaceAction, workspaceSubject)) {
        showPermissionSnackbar(...snackbarProps);
        return false;
      }

      return true;
    },
    [isWorkspaceAccessible, showPermissionSnackbar],
  );
};

export default useWorkspaceAccessibleValidation;
